import { RootState } from "config/reducers";
import { useAppDispatch } from "config/store";
import { Resiliation } from "modules/resiliation/model/resiliation";
import {  firstResiliationStep , majResiliation, previousResiliationStep, specificResiliationStep } from "modules/resiliation/service/resiliation.service";
import { FormulaireStep } from "modules/resiliation/ui/components/formulaire-step";
import { getCompagnies, getRecaptchaPublicKey } from "modules/config/store/config.selectors";
import React, { useEffect } from "react"
import { useSelector } from "react-redux";

import './formulaire.css'

export const Formulaire = () => {

    const dispatch = useAppDispatch();

    const step = useSelector((state: RootState) => state.resiliation.step);
    const inProgress = useSelector((state: RootState) => state.resiliation.inProgress);
    const resiliation = useSelector((state: RootState) => state.resiliation.resiliation);
    const recaptcha = useSelector(getRecaptchaPublicKey);
    const compagnies=  useSelector(getCompagnies);
  
    
    useEffect(()=> {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    },[step]);
   
    useEffect(()=> {
        dispatch(firstResiliationStep());
    },[]);

    const previousStep = () => {
        dispatch(previousResiliationStep());
    }

    const submit = (resiliation:Resiliation) => {
        dispatch(majResiliation(resiliation));
    }

    const goToStep = (step:any) => {
        dispatch(specificResiliationStep(step));
    }
    


    return (
        <FormulaireStep  compagnies={compagnies} inProgress={inProgress} step={step} resiliation={resiliation}  recaptcha={recaptcha} cancel={() => previousStep()} submit={submit} goToStep={goToStep} />
    )
}